/**
 * Created by jacek on 04.01.17.
 */

module.exports = require('./lib/nested-set');




// WEBPACK FOOTER //
// /node_modules/nested-set/index.js